import React from 'react';
import '../style/oldRebranding/common/modelity.scss';

const modelityOld = () => {
    return <></>
}

export default modelityOld;